import { Component } from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from "ag-grid-community";

@Component({
    selector: 'app-celllinkrenderer',
    templateUrl: './celllinkrenderer.component.html',
    styleUrls: ['./celllinkrenderer.component.scss'],
    standalone: false
})
export class CelllinkrendererComponent {
  cellValue: string = '';
  params: any = {};

  hideLink: boolean = false;
  showHideLinkText: boolean = false;
  hideLinkText: string = '';
  linkText: string = '';
  linkClass: string = '';
  linkName: string = '';
  hoverText: string = '';

  public displayValue!: string;
  paramStore: any = {};

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.displayValue = params.value;
    this.paramStore = params;

    //check for hoverText in params
    if ('hoverText' in  params) {
      this.hoverText = params['hoverText'] as string;
    }
      // Check if linkClass has been set in params
    if ('linkClass' in params) {
        this.linkClass = params['linkClass'] as string;
    }
    // Check if linkName has been set in params
    if ('linkName' in params && typeof params.linkName === 'function') {
        this.linkName = params.linkName(params);
    }
    // Check for hideLink function
    if ('hideLink' in params && typeof params.hideLink === 'function') {
      this.hideLink = params.hideLink(params);
    }

    if ('value' in params) {
      this.linkText = params.value;
    }
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
      // set value into cell again
      this.paramStore = params;
      this.cellValue = this.getValueToDisplay(params);
      return true;
  }

  linkClick(params: any) {    
    if (this.paramStore!.hasOwnProperty('callback')) {
        this.paramStore.callback(this.paramStore!.value, this.paramStore!.data!.authCode, this.paramStore!.data!.driversConsent);
    }
}

  getValueToDisplay(params: ICellRendererParams) {
      return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
